import React from 'react';
import { Box, Typography, Button, styled, Container } from '@mui/material';
import LandingPageNav from '../../components/landingpage/LandingPageNav';
import MortgageCalculator from '../../components/calculator/Calculator';
import LocationShowcase from '../../components/lopage/LocationShowcase';
import HeroLoanBanner from '../../components/lopage/HeroLoanBanner';


const ProfileContainer = styled(Container)(() => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: 8,
  paddingTop: '84px',
  position: 'relative',
  zIndex: 1,
}));

const TopContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(4),
}));

const ProfileInfo = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

const ProfileDetails = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(2),
}));

const ActionButtons = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginRight: theme.spacing(-2),
}));

const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1),
  padding: theme.spacing(2),
  fontSize: '1rem',
  textTransform: 'none',
}));

const DescriptionContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const CalculatorContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
}));

function JohnDoe() {
  return (
    <>
      <LandingPageNav />

      <HeroLoanBanner
        agentImage="/assets/images/avatars/avatar_1.jpg"
        name="Daniel Peluso"
        title="Area Manager, Mortgage Loan Officer"
        nmls="1610157"
        phone="(843) 290-4664"
        email="daniel.peluso@jethl.com"
      />

      {/* Background wrapper for profile section */}
      <Box
        sx={{
          backgroundImage: 'url(/assets/backgroundimageforherobanner.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(255, 255, 255, 0.7)',
            zIndex: 0,
          },
        }}
      >
        <ProfileContainer>
          <TopContainer>
            <ProfileInfo>
              <img
                src="/assets/images/avatars/avatar_1.jpg"
                alt="John Doe"
                style={{ width: '150px', height: '150px', borderRadius: '50%' }}
              />
              <ProfileDetails>
                <Typography variant="h5">John Doe</Typography>
                <Typography variant="subtitle1">Senior Loan Officer</Typography>
                <Typography variant="subtitle2">NMLS #123456</Typography>
                <Typography>Contact Info Here</Typography>
              </ProfileDetails>
            </ProfileInfo>
            <ActionButtons>
              <StyledButton variant="contained">Apply Now</StyledButton>
              <StyledButton variant="contained">Mortgage Calculator</StyledButton>
              <StyledButton variant="contained">Upload Documents</StyledButton>
            </ActionButtons>
          </TopContainer>

          <DescriptionContainer>
            <Typography>
              At Fake Mortgage Company, we’re dedicated to providing you with top-flight resources
              and first-class service to help you reach your dreams of homeownership. Comprised of
              some of the top mortgage talent in the industry, our team of loan professionals is
              committed to guiding you through every step of the home financing process. We’re
              looking forward to providing you with the powerful tools and resources you need to
              achieve a positive and rewarding home loan experience.
            </Typography>
          </DescriptionContainer>

          <LocationShowcase
            title="YOUR HOME FINANCING TEAM"
            image="/assets/logo-jet2.png"
            address={`12 Johnston Way Ste A & B,\nBluffton, SC, US 29910`}
            phone="(843) 290-4664"
            email="daniel.peluso@jethl.com"
          />

          <CalculatorContainer>
            <MortgageCalculator />
          </CalculatorContainer>
        </ProfileContainer>
      </Box>
    </>
  );
}

export default JohnDoe;
